(function () {
  'use strict';
  if (window.LehaCommercialPricing) return;
  var owners = new WeakMap();
  var requestDeadline = 10000;
  var retryDelay = 10000;
  var sectionRequests = new Map();
  var queuedRequests = new Set();
  var flushQueued = false;
  var retryFocus = new WeakSet();
  function sectionRequest(href, country, signal) {
    var url = new URL(href, window.location.href);
    if (url.origin !== window.location.origin) return Promise.reject(new Error('package_origin'));
    var section = url.searchParams.get('section_id');
    if (!section) return Promise.reject(new Error('pricing_section_missing'));
    var base = new URL(url.href);
    ['section_id', 'sections', '_leha_refresh'].forEach(function (key) { base.searchParams.delete(key); });
    var context = base.href + '\n' + country;
    var key = context + '\n' + section;
    var entry = sectionRequests.get(key);
    if (!entry) {
      entry = {key: key, context: context, section: section, url: url, base: base, subscribers: new Set()};
      sectionRequests.set(key, entry);
      queuedRequests.add(entry);
    }
    var result = new Promise(function (resolve, reject) {
      var subscriber = {resolve: resolve, reject: reject};
      function abort() {
        entry.subscribers.delete(subscriber);
        reject(new DOMException('Aborted', 'AbortError'));
        if (!entry.subscribers.size) {
          if (sectionRequests.get(key) === entry) sectionRequests.delete(key);
          queuedRequests.delete(entry);
          if (entry.batch && entry.batch.entries.every(function (item) { return !item.subscribers.size; })) {
            clearTimeout(entry.batch.timer); entry.batch.controller.abort();
          }
        }
      }
      subscriber.clean = function () { if (signal) signal.removeEventListener('abort', abort); };
      if (signal && signal.aborted) { abort(); return; }
      entry.subscribers.add(subscriber);
      if (signal) signal.addEventListener('abort', abort, {once: true});
    });
    if (!flushQueued) { flushQueued = true; queueMicrotask(flushRequests); }
    return result;
  }
  function finishRequest(entry, value, error) {
    if (sectionRequests.get(entry.key) === entry) sectionRequests.delete(entry.key);
    entry.subscribers.forEach(function (subscriber) {
      subscriber.clean();
      if (error) subscriber.reject(error); else subscriber.resolve(value);
    });
    entry.subscribers.clear();
  }
  function flushRequests() {
    flushQueued = false;
    var contexts = new Map();
    queuedRequests.forEach(function (entry) {
      if (!entry.subscribers.size) return;
      if (!contexts.has(entry.context)) contexts.set(entry.context, []);
      contexts.get(entry.context).push(entry);
    });
    queuedRequests.clear();
    contexts.forEach(function (entries) {
      for (var offset = 0; offset < entries.length; offset += 5) sendSections(entries.slice(offset, offset + 5));
    });
  }
  async function sendSections(entries) {
    var batch = {entries: entries, controller: new AbortController()};
    entries.forEach(function (entry) { entry.batch = batch; });
    var url = new URL(entries[0].url.href);
    var multiple = entries.length > 1;
    if (multiple) {
      url.searchParams.delete('section_id');
      url.searchParams.set('sections', entries.map(function (entry) { return entry.section; }).join(','));
    }
    var deadline = setTimeout(function () { batch.controller.abort(); }, requestDeadline);
    batch.timer = deadline;
    try {
      var response = await fetch(url.href, {cache: 'no-store', credentials: 'same-origin', signal: batch.controller.signal});
      if (!response.ok) throw new Error('pricing_response');
      var body = await response.text();
      var sections = multiple ? JSON.parse(body) : null;
      entries.forEach(function (entry) {
        var html = multiple ? sections && sections[entry.section] : body;
        var value = {ok: response.ok, status: response.status, url: response.url || url.href, redirected: response.redirected, headers: response.headers, text: async function () { return html; }};
        finishRequest(entry, value, typeof html === 'string' ? null : new Error('pricing_section_missing'));
      });
    } catch (error) {
      entries.forEach(function (entry) { finishRequest(entry, null, error); });
    } finally { clearTimeout(deadline); }
  }
  function bootstrapLease(state, variantId, country) {
    var rendered = state && Date.parse(state.resolved_at);
    var age = Date.now() - rendered;
    if (!state || state.schema_version !== 1 || state.status !== 'resolved' || String(state.variant_id) !== String(variantId) ||
        state.country_code !== country || !state.currency_code || state.effective_price == null || !Number.isFinite(age) || Math.abs(age) > 5000) return 0;
    return Math.max(0, Math.min(60, Number(state.refresh_after_seconds)) * 1000 - Math.abs(age) - performance.now() - 1000) || 0;
  }
  function presentPrice(element, mode, html, labels, retryable) {
    if (!element || !element.isConnected) return;
    var focused = element.ownerDocument.activeElement;
    if (focused && element.contains(focused) && focused.matches('[data-leha-price-retry]')) retryFocus.add(element);
    if (mode === 'resolved') {
      element.removeAttribute('aria-busy');
      if (element.innerHTML !== html) element.innerHTML = html;
      element.dataset.lehaPricePresentation = 'resolved';
      if (retryFocus.has(element)) { retryFocus.delete(element); element.tabIndex = -1; element.focus({preventScroll: true}); }
      return;
    }
    var busy = mode === 'checking';
    element.setAttribute('aria-busy', String(busy));
    if (element.dataset.lehaPricePresentation === mode) return;
    element.dataset.lehaPricePresentation = mode;
    if (busy) {
      var height = element.getBoundingClientRect().height;
      if (height > 0) element.style.minBlockSize = Math.ceil(height) + 'px';
    }
    element.replaceChildren();
    var text = document.createElement('span');
    text.className = busy ? 'leha-price-placeholder' : 'leha-price-error';
    if (busy) text.setAttribute('aria-hidden', 'true');
    else text.textContent = labels.unavailable || '';
    element.appendChild(text);
    if (!busy && retryable && labels.retry) {
      var retry = document.createElement('button');
      retry.type = 'button'; retry.className = 'leha-price-retry'; retry.dataset.lehaPriceRetry = '';
      retry.textContent = labels.retry; element.appendChild(retry);
      if (retryFocus.has(element)) { retryFocus.delete(element); retry.focus({preventScroll: true}); }
    }
  }
  function productUrl(root, variant) {
    var current = new URL(window.location.href);
    var url = new URL(variant && variant.product_url || current.href, current);
    if (url.origin !== current.origin) throw new Error('package_origin');
    var prefix = root.dataset.lehaRootUrl || current.pathname.split('/products/')[0] + '/';
    if (url.pathname.startsWith('/products/') && prefix !== '/') url.pathname = prefix.replace(/\/$/, '') + url.pathname;
    current.searchParams.forEach(function (value, key) {
      if (!['variant', 'section_id', 'sections', '_leha_refresh'].includes(key)) url.searchParams.set(key, value);
    });
    url.hash = '';
    ['section_id', 'sections', '_leha_refresh'].forEach(function (key) { url.searchParams.delete(key); });
    if (variant) url.searchParams.set('variant', String(variant.id));
    return url;
  }
  function responseLease(state, variantId, country, headers, elapsed) {
    var serverDate = Date.parse(headers.get('Date') || '');
    var renderedAt = state && Date.parse(state.resolved_at);
    var cacheAge = Number(headers.get('Age') || 0);
    if (elapsed >= requestDeadline) throw new Error('pricing_timeout');
    if (!state || state.schema_version !== 1 || String(state.variant_id) !== String(variantId) ||
        state.country_code !== country || !Number.isFinite(serverDate) || !Number.isFinite(renderedAt) ||
        !Number.isFinite(cacheAge) || cacheAge < 0 || cacheAge > 5 || Math.abs(serverDate - renderedAt) > 5000) throw new Error('stale_pricing');
    var lease = Math.min(60, Number(state.refresh_after_seconds)) * 1000 - elapsed - cacheAge * 1000 - Math.max(0, serverDate - renderedAt) - 1000;
    if (!Number.isFinite(lease) || lease <= 0) throw new Error('pricing_boundary');
    return lease;
  }
  window.LehaCommercialPricing = {
    responseLease: responseLease,
    sectionRequest: sectionRequest,
    bootstrapLease: bootstrapLease,
    presentPrice: presentPrice,
    purchaseSummary: function (root) { return owners.get(root)?.purchaseSummary() || null; },
    create: function (root, initialVariants) {
      var previous = owners.get(root);
      if (previous) previous.dispose();
      var variants = initialVariants.slice();
      var selected = null;
      var leaseUntil = 0;
      var displayUntil = 0;
      var verified = new Map();
      var country = root.dataset.lehaCountry;
      var expiryTimer;
      var deadlineTimer;
      var retryTimer;
      var request;
      var sequence = 0;
      var validatedRefreshes = 0;
      var boundaryRetries = 0;
      var disposed = false;
      var active = true;
      var connected = navigator.onLine !== false;
      var price = root.querySelector('[data-leha-price]');
      var sticky = root.querySelector('[data-leha-sticky-price]');
      var message = root.querySelector('[data-leha-pricing-message]');
      var buttons = root.querySelectorAll('[data-leha-add], [data-leha-sticky-add]');
      var input = root.querySelector('[data-leha-variant-id]');
      var form = root.querySelector('.leha-product__form');
      var quantity = root.querySelector('[data-leha-qty-input]');
      var cards = Array.from(root.querySelectorAll('.leha-package-selector__card'));
      var lastAnnouncement = '';
      var observer;
      var labels = {unavailable: root.dataset.lehaUnavailable, retry: root.dataset.lehaRetry};
      var packageRecords = new Map();
      var payloads = new WeakMap();
      root.querySelectorAll('[data-leha-variants], [data-leha-package-variant]').forEach(function (script) { payloads.set(script, script.textContent); });
      cards.forEach(function (card) {
        try { packageRecords.set(card.querySelector('[data-leha-package-option]').value, JSON.parse(card.querySelector('[data-leha-package-variant]').textContent)); } catch (error) {}
      });
      function eligible() {
        return !disposed && root.isConnected && active && !document.hidden && connected;
      }
      function canBuy() {
        return eligible() && selected && selected.available && selected.pricing &&
          (!input || String(input.value) === String(selected.id)) &&
          selected.pricing.schema_version === 1 && selected.pricing.status === 'resolved' &&
          String(selected.pricing.variant_id) === String(selected.id) &&
          selected.pricing.country_code === root.dataset.lehaCountry &&
          performance.now() < leaseUntil && validQuantity();
      }
      function validQuantity() {
        if (!quantity) return true;
        var value = Number(quantity.value);
        var min = Number(quantity.min) || 1;
        var max = quantity.max === '' ? Infinity : Number(quantity.max);
        var step = Number(quantity.step) || 1;
        return Number.isSafeInteger(value) && value >= min && value <= max && (value - min) % step === 0;
      }
      function identity() {
        if (!selected) return;
        if (input) input.value = selected.id;
        var add = root.querySelector('[data-leha-add]');
        if (add) add.setAttribute('product_id', selected.id);
        root.dataset.lehaSelectedVariant = String(selected.id);
        root.dataset.lehaSelectedProduct = selected.product_id || root.dataset.lehaProductId || '';
        if (form && selected.product_id) form.querySelectorAll('input[name="product-id"], input[name="product_id"]').forEach(function (field) { field.value = selected.product_id; });
        if (quantity && Number.isInteger(selected.quantity_min) && Number.isInteger(selected.quantity_max) && Number.isInteger(selected.quantity_step)) {
          quantity.min = selected.quantity_min;
          quantity.max = selected.quantity_max;
          quantity.step = selected.quantity_step;
          var min = selected.quantity_min;
          var ceiling = min + Math.floor((selected.quantity_max - min) / selected.quantity_step) * selected.quantity_step;
          var value = Number(quantity.value);
          quantity.value = Math.max(min, Math.min(ceiling, min + Math.floor((Number.isFinite(value) ? value - min : 0) / selected.quantity_step) * selected.quantity_step));
        }
      }
      function cardPrices(mode, records) {
        var now = performance.now();
        cards.forEach(function (card) {
          var radio = card.querySelector('[data-leha-package-option]');
          var fresh = records && records.find(function (item) { return String(item.id) === radio.value; });
          if (fresh) packageRecords.set(radio.value, fresh);
          var item = packageRecords.get(radio.value);
          var confirmed = item && item.pricing.country_code === root.dataset.lehaCountry && now < (verified.get(radio.value) || 0);
          var usable = item && item.pricing.status === 'resolved' && item.pricing.country_code === root.dataset.lehaCountry &&
            (now < (verified.get(radio.value) || 0) || mode === 'checking' && bootstrapLease(item.pricing, radio.value, root.dataset.lehaCountry) > 0);
          var amount = card.querySelector('[data-leha-package-price]');
          var badge = card.querySelector('[data-leha-package-badge]');
          if (fresh) {
            var serialized = JSON.stringify(fresh);
            var data = card.querySelector('[data-leha-package-variant]');
            payloads.set(data, serialized);
            if (data.textContent !== serialized) data.textContent = serialized;
          }
          presentPrice(amount, usable ? 'resolved' : mode === 'checking' && !confirmed ? 'checking' : 'unavailable', usable ? item.sticky_price_html : '', labels, false);
          if (badge) badge.hidden = !usable || item.pricing.source !== 'seasonal_offer' || !item.pricing.offer_reference;
        });
      }
      function announce(value) {
        if (message && value !== lastAnnouncement) message.textContent = value;
        lastAnnouncement = value;
      }
      function paint(mode) {
        root.dataset.lehaRefreshStatus = mode || 'unavailable';
        var state = selected && selected.pricing;
        var fresh = eligible() && performance.now() < Math.max(leaseUntil, displayUntil) && state && state.country_code === root.dataset.lehaCountry;
        var label = mode === 'checking' ? root.dataset.lehaChecking :
          mode === 'retrying' ? root.dataset.lehaRetrying || root.dataset.lehaUnavailable : root.dataset.lehaUnavailable;
        if (fresh && state && state.status === 'resolved') {
          root.dataset.lehaRefreshStatus = performance.now() < leaseUntil ? 'resolved' : 'checking';
          presentPrice(price, 'resolved', selected.price_html, labels, true);
          presentPrice(sticky, 'resolved', selected.sticky_price_html, labels, true);
          label = selected.available ? root.dataset.lehaAddLabel : root.dataset.lehaSoldOut;
          var chosen = cards.find(function (card) { return card.querySelector('[data-leha-package-option]').checked; });
          var name = chosen && chosen.querySelector('[data-leha-package-label]').textContent.trim();
          announce(performance.now() < leaseUntil ? (name ? (root.dataset.lehaPackageSelected || '') + ': ' + name + '، ' : '') + state.effective_price + ' ' + state.currency_code : root.dataset.lehaChecking);
        } else {
          var checking = mode === 'checking' && !(performance.now() < leaseUntil && state && state.country_code === root.dataset.lehaCountry);
          [price, sticky].forEach(function (element) { presentPrice(element, checking ? 'checking' : 'unavailable', '', labels, true); });
          announce(checking ? root.dataset.lehaChecking : labels.unavailable);
        }
        buttons.forEach(function (button) {
          button.disabled = !canBuy();
          button.setAttribute('aria-busy', String(mode === 'checking' && !canBuy()));
          var text = button.querySelector('span') || button;
          var readyLabel = state && state.status === 'resolved' ? selected.available ? root.dataset.lehaAddLabel : root.dataset.lehaSoldOut : labels.unavailable;
          if (text.textContent !== readyLabel) text.textContent = readyLabel;
        });
        var values = {
          country: state && state.country_code === root.dataset.lehaCountry && state.country_code,
          price: canBuy() && state.effective_price,
          currency: state && state.country_code === root.dataset.lehaCountry && state.currency_code,
          source: canBuy() && (selected.pricing_source || 'local'),
          offer: canBuy() && selected.offer_handle
        };
        Object.keys(values).forEach(function (key) {
          var element = root.querySelector('[data-leha-snapshot-' + key + ']');
          if (element) element.value = values[key] || '';
        });
      }
      function invalidate(mode, preserve) {
        sequence += 1;
        if (!preserve) { leaseUntil = displayUntil = 0; verified.clear(); }
        clearTimeout(expiryTimer);
        clearTimeout(deadlineTimer);
        clearTimeout(retryTimer);
        expiryTimer = deadlineTimer = retryTimer = undefined;
        if (request) request.abort();
        request = null;
        cardPrices(preserve ? mode : 'unavailable');
        paint(mode);
      }
      function owns(generation) {
        if (!root.isConnected) dispose();
        return generation === sequence && eligible();
      }
      function recover(generation, delay, mode) {
        if (!owns(generation)) return;
        invalidate(mode);
        if (root.dataset.lehaRefreshDiagnostic === 'pricing_boundary' && boundaryRetries++ < 1) retryTimer = setTimeout(refresh, delay);
      }
      function protect(event) {
        if (event.type === 'click' && !event.target.closest('[data-leha-add], [data-leha-sticky-add]')) return;
        if (!canBuy()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (!root.isConnected) dispose();
          else if (leaseUntil) refresh();
        }
      }
      async function refresh() {
        if (!root.isConnected) { dispose(); return; }
        if (!selected || !eligible() || request) return;
        invalidate('checking', true);
        var displayExpiry = Math.max(leaseUntil, displayUntil) - performance.now();
        if (displayExpiry > 0) expiryTimer = setTimeout(function () { paint('checking'); cardPrices('checking'); }, displayExpiry);
        var controller = new AbortController();
        request = controller;
        var ownSequence = sequence;
        var selectedId = String(selected.id);
        var started = performance.now();
        deadlineTimer = setTimeout(function () { if (owns(ownSequence)) root.dataset.lehaRefreshDiagnostic = 'pricing_timeout'; recover(ownSequence, retryDelay, 'retrying'); }, requestDeadline);
        try {
          var url = productUrl(root, selected);
          url.searchParams.set('section_id', root.dataset.lehaSectionId);
          url.searchParams.set('variant', selectedId);
          url.searchParams.set('_leha_refresh', String(Date.now()) + '-' + ownSequence);
          root.dataset.lehaRequestUrl = url.href;
          root.dataset.lehaRequestVariant = selectedId;
          root.dataset.lehaRefreshAttempt = String(ownSequence);
          var response = await sectionRequest(url.href, root.dataset.lehaCountry, controller.signal);
          if (!owns(ownSequence)) return;
          root.dataset.lehaResponseStatus = String(response.status);
          root.dataset.lehaResponseDate = response.headers.get('Date') || '';
          root.dataset.lehaResponseAge = response.headers.get('Age') || '';
          root.dataset.lehaResponseContentType = response.headers.get('Content-Type') || '';
          root.dataset.lehaResponseUrl = response.url || '';
          root.dataset.lehaResponseRedirected = String(!!response.redirected);
          if (!response.ok) throw new Error('pricing_response');
          var serverDate = Date.parse(response.headers.get('Date') || '');
          var cacheAge = Number(response.headers.get('Age') || 0);
          var html = await response.text();
          if (!owns(ownSequence)) return;
          var fragment = new DOMParser().parseFromString(html, 'text/html');
          var nextRoot = fragment.querySelector('[data-leha-product]');
          root.dataset.lehaResponseCountry = nextRoot && nextRoot.dataset.lehaCountry || '';
          root.dataset.lehaResponseSectionId = nextRoot && nextRoot.dataset.lehaSectionId || '';
          if (!nextRoot) throw new Error('pricing_section_missing');
          if (nextRoot.dataset.lehaSectionId !== root.dataset.lehaSectionId) throw new Error('pricing_section_mismatch');
          if (nextRoot.dataset.lehaCountry !== root.dataset.lehaCountry) throw new Error('country_changed');
          var data = nextRoot.querySelector('[data-leha-variants]');
          var freshVariants = data && JSON.parse(data.textContent);
          if (!Array.isArray(freshVariants)) throw new Error('pricing_missing');
          var packageVariants = Array.from(nextRoot.querySelectorAll('[data-leha-package-variant]')).map(function (element) { return JSON.parse(element.textContent); });
          var freshRecords = packageVariants.concat(freshVariants);
          var freshSelected = freshVariants.find(function (variant) { return String(variant.id) === selectedId; });
          if (selected.product_id && (!freshSelected || String(freshSelected.product_id) !== String(selected.product_id) || nextRoot.dataset.lehaProductId !== String(selected.product_id))) throw new Error('package_product_mismatch');
          var state = freshSelected && freshSelected.pricing;
          var renderedAt = state && Date.parse(state.resolved_at);
          root.dataset.lehaRenderedAt = state && state.resolved_at || '';
          var elapsed = performance.now() - started;
          root.dataset.lehaRequestDurationMs = String(Math.round(elapsed));
          root.dataset.lehaFreshnessDeltaMs = Number.isFinite(serverDate) && Number.isFinite(renderedAt) ? String(serverDate - renderedAt) : '';
          var lease = responseLease(state, selectedId, root.dataset.lehaCountry, response.headers, elapsed);
          cards.forEach(function (card) {
            var radio = card.querySelector('[data-leha-package-option]');
            var previousState = packageRecords.get(radio.value);
            var fresh = freshRecords.find(function (item) { return String(item.id) === radio.value; });
            if (!fresh || String(fresh.product_id) !== String(previousState.product_id)) throw new Error('package_option_missing');
            lease = Math.min(lease, responseLease(fresh.pricing, radio.value, root.dataset.lehaCountry, response.headers, elapsed));
          });
          if (!owns(ownSequence)) return;
          clearTimeout(deadlineTimer);
          deadlineTimer = undefined;
          request = null;
          freshRecords.forEach(function (fresh) {
            var index = variants.findIndex(function (item) { return String(item.id) === String(fresh.id); });
            if (index === -1) variants.push(fresh); else variants[index] = fresh;
          });
          selected = freshSelected;
          identity();
          leaseUntil = performance.now() + lease;
          displayUntil = 0;
          verified.clear();
          verified.set(selectedId, leaseUntil);
          cards.forEach(function (card) { verified.set(card.querySelector('[data-leha-package-option]').value, leaseUntil); });
          root.dataset.lehaRefreshDiagnostic = '';
          validatedRefreshes += 1;
          boundaryRetries = 0;
          root.dataset.lehaValidatedRefreshes = String(validatedRefreshes);
          paint();
          cardPrices('resolved', freshRecords);
          root.dispatchEvent(new CustomEvent('leha:pricing:updated', { detail: { variant: selected }, bubbles: true }));
          clearTimeout(expiryTimer);
          expiryTimer = setTimeout(refresh, lease);
        } catch (error) {
          if (owns(ownSequence)) root.dataset.lehaRefreshDiagnostic = error.message;
          recover(ownSequence, error.message === 'pricing_boundary' ? 1000 : retryDelay, 'retrying');
        }
      }
      function resume() {
        if (!root.isConnected) { dispose(); return; }
        if (country !== root.dataset.lehaCountry) { country = root.dataset.lehaCountry; invalidate('checking'); }
        if (request || performance.now() < leaseUntil) return;
        refresh();
      }
      function visibility() { if (document.hidden) invalidate(); else resume(); }
      function offline() { connected = false; invalidate(); }
      function online() { connected = true; resume(); }
      function pagehide() { active = false; invalidate(); }
      function pageshow(event) { active = true; if (event.persisted) invalidate('checking'); resume(); }
      function retry(event) {
        if (!event.target.closest('[data-leha-price-retry]')) return;
        event.preventDefault(); event.stopImmediatePropagation(); boundaryRetries = 0; refresh();
      }
      function unload(event) {
        if (event.target === root || event.target.contains(root) ||
            event.detail && event.detail.sectionId === root.dataset.lehaSectionId) dispose();
      }
      function dispose() {
        if (disposed) return;
        disposed = true;
        invalidate();
        root.removeEventListener('click', protect, true);
        root.removeEventListener('click', retry, true);
        if (form) form.removeEventListener('submit', protect, true);
        if (quantity) quantity.removeEventListener('change', quantityChanged);
        document.removeEventListener('visibilitychange', visibility);
        document.removeEventListener('shopify:section:unload', unload);
        window.removeEventListener('pageshow', pageshow);
        window.removeEventListener('pagehide', pagehide);
        window.removeEventListener('focus', resume);
        window.removeEventListener('online', online);
        window.removeEventListener('offline', offline);
        if (observer) observer.disconnect();
        owners.delete(root);
      }
      var api = {
        purchaseSummary: function () {
          if (!canBuy()) return null;
          return {variantId:String(selected.id),country:selected.pricing.country_code,currency:selected.pricing.currency_code,unitPrice:selected.pricing.effective_price,priceHtml:selected.sticky_price_html,state:JSON.parse(JSON.stringify(selected.pricing))};
        },
        select: function (variant) {
          if (disposed) return;
          var id = variant && String(variant.id);
          if (selected && id === String(selected.id) && country === root.dataset.lehaCountry && (request || performance.now() < leaseUntil)) return;
          var until = country === root.dataset.lehaCountry && verified.get(id) || 0;
          if (country !== root.dataset.lehaCountry) verified.clear();
          selected = id && variants.find(function (item) { return String(item.id) === id; }) || null;
          country = root.dataset.lehaCountry;
          leaseUntil = until;
          displayUntil = selected ? performance.now() + bootstrapLease(selected.pricing, id, country) : 0;
          identity();
          invalidate(eligible() ? 'checking' : undefined, true);
          if (performance.now() < leaseUntil) { expiryTimer = setTimeout(refresh, leaseUntil - performance.now()); return; }
          refresh();
        },
        urlFor: function (variant) { return productUrl(root, variant); },
        dispose: dispose
      };
      function quantityChanged() { paint(); }
      owners.set(root, api);
      root.addEventListener('click', protect, true);
      root.addEventListener('click', retry, true);
      if (form) form.addEventListener('submit', protect, true);
      if (quantity) quantity.addEventListener('change', quantityChanged);
      document.addEventListener('visibilitychange', visibility);
      document.addEventListener('shopify:section:unload', unload);
      window.addEventListener('pageshow', pageshow);
      window.addEventListener('pagehide', pagehide);
      window.addEventListener('focus', resume);
      window.addEventListener('online', online);
      window.addEventListener('offline', offline);
      observer = new MutationObserver(function (records) {
        if (!root.isConnected) dispose();
        else if (records.some(function (record) {
          var script = record.target.nodeType === 1 ? record.target : record.target.parentElement;
          if (!script || !payloads.has(script) || payloads.get(script) === script.textContent) return false;
          payloads.set(script, script.textContent); return true;
        })) { country = root.dataset.lehaCountry; invalidate('checking'); refresh(); }
        else if (records.some(function (record) { return record.type === 'attributes'; })) resume();
      });
      observer.observe(document.documentElement, {childList: true, subtree: true});
      observer.observe(root, {attributes: true, attributeFilter: ['data-leha-country']});
      if (!root.isConnected) dispose();
      return api;
    }
  };
}());
